import styled from 'styled-components';

const TableActionsWrapper = styled.div`
    border: 1px solid #dee2e6;
    border-left: 0;
    border-right: 0;
    padding: 6px 0;
    background: #f8f9fa;
`;

export default TableActionsWrapper;